import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Pagination,
  Loading,
  Button,
  Select,
  Input,
} from '../../../../components/base';
import language from '../../../../languages';
import { formatData } from '../../../../utils/transformer.util';
import { FINANCE_NON_KAS_JOURNAL_TABLE_FIELDS } from '../../../../constants/finance/bookeeping.constant';

const initialContent = {
  loading: true,
  data: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

const monthOptions = () => {
  const options = [{ value: '', label: 'Semua' }];
  const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
  for (let i = 0; i < 12; i += 1) {
    options.push({ value: i, label: months[i] });
  }
  return options;
};

const yearOptions = () => {
  const d = new Date();
  const year = d.getFullYear();
  const options = [{ value: '', label: 'Semua' }];
  for (let i = 2020; i <= year; i += 1) {
    options.push({ value: i, label: i });
  }
  return options;
};

const isPostedOptions = [
  { value: '', label: 'Semua' },
  { value: 1, label: 'Terposting' },
  { value: 0, label: 'Belum Terposting' },
];

const isCreditOptions = [
  { value: '', label: 'Semua' },
  { value: 1, label: 'Kas Masuk' },
  { value: 0, label: 'Kas Keluar' },
];

export default class NonKasJournal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: initialContent,
      listAmount: 20,
      filters: {},
    };
    this._onClickAdd = this._onClickAdd.bind(this);
    this._onClickEdit = this._onClickEdit.bind(this);
    this._onClickActionButton = this._onClickActionButton.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._renderButtons = this._renderButtons.bind(this);
  }

  componentDidMount() {
    this._onSearchContent({ page: 1 });
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    this.setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }), () => this._onSearchContent());
  }

  async _onSearchContent(params) {
    try {
      const { handleGetNonKasJournal } = this.props;
      const {
        data = [], current_page = 1, total = 0, last_page = 1,
      } = await handleGetNonKasJournal({ page: params, filters: this.state.filters });
      this.setState({
        content: {
          loading: false,
          list: data,
          currentPage: current_page,
          total,
          totalPage: last_page,
        },
      });
    } catch (err) {
      this.setState({
        content: {
          loading: false,
          list: [],
          currentPage: 1,
          total: 1,
          totalPage: 1,
          error: true,
        },
      });
    }
  }

  _onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/keuangan/pembukuan/kelola-jurnal-non-kas', { isEdit: false });
  }

  _onClickEdit(val) {
    const { history } = this.props;
    history.push('/dashboard/keuangan/pembukuan/kelola-jurnal-non-kas', { data: { journal_number: val.journal_number }, isEdit: true });
  }

  async _onClickPostingButton(val) {
    const { handlePostingNonKasJournal } = this.props;
    await handlePostingNonKasJournal({ journal_number: val });
    this._onSearchContent({ page: 1 });    
  }

  _onClickActionButton(val) {
    const { history } = this.props;
    history.push(`/dashboard/keuangan/pembukuan/jurnal-non-kas/${val.journal_number}`);
  }

  _renderButtons(data) {
    if (!data) {
      return false;
    }

    if (data.is_posted === 0) {
      return ([
        <Button
          key="button_edit"
          onClick={() => this._onClickEdit(data)}
          title="Edit"
        />,
        <Button
          key="button_post"
          onClick={() => this._onClickPostingButton(data)}
          title="Post"
        />,
      ]);
    }
    return ([
      <Button
        key="button_preview"
        onClick={() => this._onClickActionButton(data)}
        title="Preview"
      />,
    ]);
  }

  render() {
    const {
      listAmount,
      content,
      filters,
    } = this.state;
    const {
      month = '',
      year = '',
      is_credit = '',
      is_posted = '',
      journal_number = '',
    } = filters;
    const loadingProps = { show: content.loading };
    return (
      <div className="cash-journal">
        <Button
          title="Tambah Jurnal Non Kas"
          onClick={this._onClickAdd}
        />
        <div className="cash-journal__content">
          <div className="content-table">
            <div className="table-filters">
              <Input
                placeholder="Nomor Jurnal"
                type="text"
                name="journal_number"
                value={journal_number}
                onChange={this._onChangeFilter}
              />
              <Select
                placeholder="Bulan Jurnal"
                name="month"
                value={month}
                data={monthOptions()}
                onChange={this._onChangeFilter}
              />
              <Select
                placeholder="Tahun Jurnal"
                name="year"
                value={year}
                data={yearOptions()}
                onChange={this._onChangeFilter}
              />
              <Select
                placeholder="Status Jurnal"
                name="is_posted"
                value={is_posted}
                data={isPostedOptions}
                onChange={this._onChangeFilter}
              />
              <Select
                placeholder="Jenis Jurnal"
                name="is_credit"
                value={is_credit}
                data={isCreditOptions}
                onChange={this._onChangeFilter}
              />
            </div>
            {
              content.loading
                ? <Loading loading={loadingProps} />
                : (
                  <table className="table">
                    <thead>
                      <tr>
                        {
                          FINANCE_NON_KAS_JOURNAL_TABLE_FIELDS.label.map((field, idx) => (
                            <th key={`table_th_${idx}`}>{field}</th>
                          ))
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {
                      content.list.map((list, idx) => (
                        <tr key={`non_cash_journal_tr_${idx}`}>
                          {
                            FINANCE_NON_KAS_JOURNAL_TABLE_FIELDS.value.map((field, fieldIdx) => {
                              if (fieldIdx === 0) {
                                return (
                                  <td key={`table_${fieldIdx}_${idx}`}>{(idx + 1) + ((content.currentPage - 1) * listAmount)}</td>
                                );
                              }
                              return (
                                <td
                                  className={(field.type === 'number') ? 'nominal' : ''}
                                  key={`table_${fieldIdx}_${idx}`}
                                >{formatData(list, field)}
                                </td>
                              );
                            })
                          }

                          <td>
                            <div className="table__actions">
                              {this._renderButtons(list)}
                            </div>
                          </td>
                        </tr>
                      ))
                    }
                    </tbody>
                  </table>
                )
            }
            <div className="non_cash_journal__table-footer">
              <p className="non_cash_journal__page-info">
                {`${language.translate.COMPONENT__CONTENT_TABLE__PAGE} ${content.currentPage} ${language.translate.COMPONENT__CONTENT_TABLE__OF} ${content.totalPage}`}
              </p>
              <Pagination
                totalPage={content.totalPage}
                currentPage={content.currentPage}
                onClick={this._onSearchContent}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
NonKasJournal.propTypes = {
  handleGetNonKasJournal: PropTypes.func.isRequired,
  handlePostingNonKasJournal: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};
